module.exports = __webpack_public_path__ + "static/img/Houda.a779ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Houda.png
// module id = lwv8
// module chunks = 1